// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datagridFluid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  grid-auto-rows: minmax(50px, auto);
  grid-gap: 12.5px;
}
.loadingWrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.datagridFixed {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 50px);
  grid-auto-rows: minmax(50px, auto);
  grid-gap: 12.5px;
}
.loadMore {
  background-color: #FBFBFB;
  height: 50px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loadMore :global i {
  cursor: pointer;
  color: #C4408F;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/DataGrid.less"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,aAAA;EACA,0DAAA;EACA,kCAAA;EACA,gBAAA;AADF;AAIA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFF;AAKA;EACE,WAAA;EACA,aAAA;EACA,8CAAA;EACA,kCAAA;EACA,gBAAA;AAHF;AAMA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJF;AAFA;EAQI,eAAA;EACA,cAAA;AAHJ","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.datagridFluid {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));\n  grid-auto-rows: minmax(50px, auto);\n  grid-gap: 12.5px;\n}\n\n.loadingWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.datagridFixed {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 50px);\n  grid-auto-rows: minmax(50px, auto);\n  grid-gap: 12.5px;\n}\n\n.loadMore {\n  background-color: @background-white2;\n  height: 50px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  :global i {\n    cursor: pointer;\n    color: @menu-primary;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
